module.exports = __webpack_public_path__ + "static/img/3.691408a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3.png
// module id = U+2z
// module chunks = 1